import React from "react";
import i18n from "../../i18n";

export class PasswordRules extends React.Component {
  constructor() {
    super();
    this.state = {
      open_rules: false,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    let { rules } = this.props;
    let { open_rules } = this.state;
    return (
      <React.Fragment>
        {!open_rules && (
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <span
                className="text-info"
                onClick={() => {
                  this.setState({ open_rules: true });
                }}
              >
                <small>{i18n.t("see_rules")}</small>
              </span>
            </div>
            {/** Rules short */}
            <div className="d-flex justify-content-start align-items-center gap-1 mt-2">
              <div
                className={`border rounded px-2 ${
                  rules?.char8
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
              >
                <small>8+</small>
              </div>
              <div
                className={`border rounded px-2 ${
                  rules?.charSpecial
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
              >
                <small>!#@</small>
              </div>
              <div
                className={`border rounded px-2 ${
                  rules?.number
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
              >
                <small>0-9</small>
              </div>
              <div
                className={`border rounded px-2 ${
                  rules?.capital
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
              >
                <small>A-Z</small>
              </div>
              <div
                className={`border rounded px-2 ${
                  rules?.small
                    ? "text-success border-success"
                    : "text-danger border-danger"
                }`}
              >
                <small>a-z</small>
              </div>
            </div>
          </div>
        )}
        <div className={open_rules ? "" : "d-none"}>
          <div className="d-flex justify-content-end">
            <span
              className="text-info"
              onClick={() => {
                this.setState({ open_rules: false });
              }}
            >
              <small>{i18n.t("hide_rules")}</small>
            </span>
          </div>
          <div>
            <i
              className={`mdi ${
                rules?.char8
                  ? "mdi-check-circle-outline text-success"
                  : "mdi-close-box text-danger"
              }`}
            />{" "}
            &nbsp; {i18n.t("password_length")}
          </div>
          <div>
            <i
              className={`mdi ${
                rules?.charSpecial
                  ? "mdi-check-circle-outline text-success"
                  : "mdi-close-box text-danger"
              }`}
            />{" "}
            &nbsp; {i18n.t("password_special")}
          </div>
          <div>
            <i
              className={`mdi ${
                rules?.number
                  ? "mdi-check-circle-outline text-success"
                  : "mdi-close-box text-danger"
              }`}
            />{" "}
            &nbsp; {i18n.t("password_number")}
          </div>
          <div>
            <i
              className={`mdi ${
                rules?.capital
                  ? "mdi-check-circle-outline text-success"
                  : "mdi-close-box text-danger"
              }`}
            />{" "}
            &nbsp; {i18n.t("password_capital")}
          </div>
          <div>
            <i
              className={`mdi ${
                rules?.small
                  ? "mdi-check-circle-outline text-success"
                  : "mdi-close-box text-danger"
              }`}
            />{" "}
            &nbsp; {i18n.t("password_small")}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
